import sorcerer from '@/assets/avatars/sorcerer.png';
import simba from '@/assets/avatars/simba.png';
import trickster from '@/assets/avatars/trickster.png';
import goldenPrincess from '@/assets/avatars/golden-princess.png';
import dragon from '@/assets/avatars/dragon.png';
import owlSage from '@/assets/avatars/owl-sage.png';
import knight from '@/assets/avatars/knight.png';
import forestFairy from '@/assets/avatars/forest-fairy.png';
import pirateFox from '@/assets/avatars/pirate-fox.png';
import enchantress from '@/assets/avatars/enchantress.png';
import phoenix from '@/assets/avatars/phoenix.png';
import wolfWarrior from '@/assets/avatars/wolf-warrior.png';
import mageApprentice from '@/assets/avatars/mage-apprentice.png';
import seaSerpent from '@/assets/avatars/sea-serpent.png';
import treasureRaccoon from '@/assets/avatars/treasure-raccoon.png';
import shadowRogue from '@/assets/avatars/shadow-rogue.png';
import unicorn from '@/assets/avatars/unicorn.png';
import steampunkRobot from '@/assets/avatars/steampunk-robot.png';
import mouseWarrior from '@/assets/avatars/mouse-warrior.png';
import treeSpirit from '@/assets/avatars/tree-spirit.png';
import starGuardian from '@/assets/avatars/star-guardian.png';
import flamingoDancer from '@/assets/avatars/flamingo-dancer.png';
import crystalGolem from '@/assets/avatars/crystal-golem.png';
import bearShaman from '@/assets/avatars/bear-shaman.png';
import catWitch from '@/assets/avatars/cat-witch.png';
import frostGiant from '@/assets/avatars/frost-giant.png';
import sunPriestess from '@/assets/avatars/sun-priestess.png';
import crowTrickster from '@/assets/avatars/crow-trickster.png';
import fireElemental from '@/assets/avatars/fire-elemental.png';
import turtleElder from '@/assets/avatars/turtle-elder.png';
import hawkArcher from '@/assets/avatars/hawk-archer.png';
import mushroomAlchemist from '@/assets/avatars/mushroom-alchemist.png';
import inkSquid from '@/assets/avatars/ink-squid.png';
import stormDjinn from '@/assets/avatars/storm-djinn.png';
import clockworkInventor from '@/assets/avatars/clockwork-inventor.png';

export interface AvatarOption {
  id: string;
  label: string;
  src: string;
}

export const AVATAR_OPTIONS: AvatarOption[] = [
  { id: 'sorcerer', label: 'Sorcerer', src: sorcerer },
  { id: 'simba', label: 'Lion King', src: simba },
  { id: 'trickster', label: 'Trickster', src: trickster },
  { id: 'golden-princess', label: 'Golden Princess', src: goldenPrincess },
  { id: 'dragon', label: 'Fire Dragon', src: dragon },
  { id: 'owl-sage', label: 'Owl Sage', src: owlSage },
  { id: 'knight', label: 'Knight', src: knight },
  { id: 'forest-fairy', label: 'Forest Fairy', src: forestFairy },
  { id: 'pirate-fox', label: 'Pirate Fox', src: pirateFox },
  { id: 'enchantress', label: 'Enchantress', src: enchantress },
  { id: 'phoenix', label: 'Phoenix', src: phoenix },
  { id: 'wolf-warrior', label: 'Wolf Warrior', src: wolfWarrior },
  { id: 'mage-apprentice', label: 'Mage Apprentice', src: mageApprentice },
  { id: 'sea-serpent', label: 'Sea Serpent', src: seaSerpent },
  { id: 'treasure-raccoon', label: 'Treasure Hunter', src: treasureRaccoon },
  { id: 'shadow-rogue', label: 'Shadow Rogue', src: shadowRogue },
  { id: 'unicorn', label: 'Unicorn', src: unicorn },
  { id: 'steampunk-robot', label: 'Steampunk Bot', src: steampunkRobot },
  { id: 'mouse-warrior', label: 'Mouse Warrior', src: mouseWarrior },
  { id: 'tree-spirit', label: 'Tree Spirit', src: treeSpirit },
  { id: 'star-guardian', label: 'Star Guardian', src: starGuardian },
  { id: 'flamingo-dancer', label: 'Flamingo Dancer', src: flamingoDancer },
  { id: 'crystal-golem', label: 'Crystal Golem', src: crystalGolem },
  { id: 'bear-shaman', label: 'Bear Shaman', src: bearShaman },
  { id: 'cat-witch', label: 'Cat Witch', src: catWitch },
  { id: 'frost-giant', label: 'Frost Giant', src: frostGiant },
  { id: 'sun-priestess', label: 'Sun Priestess', src: sunPriestess },
  { id: 'crow-trickster', label: 'Crow Trickster', src: crowTrickster },
  { id: 'fire-elemental', label: 'Fire Elemental', src: fireElemental },
  { id: 'turtle-elder', label: 'Turtle Elder', src: turtleElder },
];

// Extra options not in the main 30 but available
export const EXTRA_AVATARS: AvatarOption[] = [
  { id: 'hawk-archer', label: 'Hawk Archer', src: hawkArcher },
  { id: 'mushroom-alchemist', label: 'Alchemist', src: mushroomAlchemist },
  { id: 'ink-squid', label: 'Ink Squid', src: inkSquid },
  { id: 'storm-djinn', label: 'Storm Djinn', src: stormDjinn },
  { id: 'clockwork-inventor', label: 'Inventor', src: clockworkInventor },
];

export function getAvatarById(id: string | null | undefined): AvatarOption | undefined {
  if (!id) return undefined;
  return [...AVATAR_OPTIONS, ...EXTRA_AVATARS].find(a => a.id === id);
}
